import React, { useState } from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { toast } from 'react-toastify';
import { ContactService } from '@/services/ContactService';

const BUSINESS_NAME = 'My Local App Business';

const ContactPage: React.FC = () => {
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [message, setMessage] = useState('');
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!name.trim() || !email.trim() || !message.trim()) {
			toast.error('Please fill in all fields.');
			return;
		}
		setLoading(true);
		try {
			await ContactService.send({ name: name.trim(), email: email.trim(), message: message.trim() });
			toast.success('Message sent successfully. We\'ll get back to you soon.');
			setName('');
			setEmail('');
			setMessage('');
		} catch (error: any) {
			console.error('Error sending contact:', error);
			toast.error(error.message || 'Failed to send message. Please try again.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<Box sx={{ py: 6 }}>
			<Container maxWidth="sm">
				<Paper variant="outlined" sx={{ p: 4 }}>
					<Typography variant="h4" fontWeight={700} gutterBottom>
						Contact
					</Typography>
					<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
						{BUSINESS_NAME}
					</Typography>

					<form onSubmit={handleSubmit}>
						<Stack spacing={2}>
							<TextField
								label="Name"
								value={name}
								onChange={(e) => setName(e.target.value)}
								fullWidth
								required
							/>
							<TextField
								label="Email"
								type="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								fullWidth
								required
							/>
							<TextField
								label="Message"
								value={message}
								onChange={(e) => setMessage(e.target.value)}
								multiline
								rows={4}
								fullWidth
								required
							/>
							<Button type="submit" variant="contained" size="large" disabled={loading}>
								{loading ? 'Sending…' : 'Send message'}
							</Button>
						</Stack>
					</form>
				</Paper>
			</Container>
		</Box>
	);
};

export default ContactPage;
